// import * as rxui from 'rxui-lite';
// 暂时不使用rxui-lite，否则schemaslot中卡片数据不更新
import * as rxui from '@mybricks/rxui';
import * as compilerJS from '@fangzhou/compiler-js';
import * as comUtils from '@fangzhou/com-utils';
import Yoda from '@ks/yoda-js-sdk';
import * as YodaKuaishouPlugin from '@ks/yoda-kuaishou-plugin';
import app from '@es/request/lib/packages/app';
import { genTraceId } from '@es/traceid';
import * as designerService from '@fangzhou/plugin-service/lib/h5';
import log from './log';
import dayjs from 'dayjs';
import './sentry';
import './px2vw';
// ktaro 依赖
import { defineCustomElements, applyPolyfills } from '@fangzhou/ktaro-components-wc/loader';
import reactifyWc from '@fangzhou/ktaro-reactify-wc';
window.reactifyWc = reactifyWc;

if (!window.Yoda) {
  window.Yoda = Yoda;
  window.yoda = Yoda; //挂载yoda，给weblogger消费，勿删
  Yoda.plugin(YodaKuaishouPlugin);
}

applyPolyfills().then(function () {
  defineCustomElements(window);
});

if (!Array.prototype.flat) {
  Object.defineProperty(Array.prototype, 'flat', {
    value: function (depth = 1) {
      return this.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) && depth > 1 ? toFlatten.flat(depth - 1) : toFlatten);
      }, []);
    },
  });
}

const getRequestAgent = () => {
  return app.create({
    kpn: 'KUAISHOU', //快手产品名称，用于区分来源 在快手app端是KUAISHOU，极速版是NEBULA，pc端需要去快手产品中台自行注册
    kpf: '', // 快手产品平台，用于区分来源，默认会设置，可不传
    yoda: window.Yoda, // 目前是在app端sig3签名用
    logConfig: {
      logger: log, // 用来网络库异常、接口日志收集
    },
    traceIdGenerator: genTraceId,
    formatResponse(response) {
      return response;
    },
  });
};

window.comUtils = comUtils;
window.rxui = rxui;
window['@mybricks/rxui'] = rxui;
// 兼容云组件
window['@fangzhou/compiler-js'] = compilerJS;
window['@mybricks/compiler-js'] = compilerJS;
window.dayjs = dayjs;
window.weblog = log;
window.getRequestAgent = getRequestAgent;
window.designerService = designerService;
